import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AttributesMappingActionsValidator {

    field = [
        Validators.required
    ];
    name = [
        Validators.required
    ];
    type = [
        Validators.required
    ];
    attribute_id = [
        Validators.required
    ];
    attribute_group_id = [
        Validators.required
    ];
    foreign_attribute_id = [
        Validators.required
    ];

    // Error messages
    errorMessages = {
        name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        type: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_group_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        foreign_attribute_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}